import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DataDesc } from '../wxDataDesc';
import { DataModule } from '../wxDataModule';
import { DatasetState } from '../wxDataDesc/wxDataDesc';
import { WxIBlobDataItem } from '../wxDataDesc/wxIBlobDataItem';

export default class SimpleForm extends Vue {
    protected xDataModule!: DataModule;
    protected xDataDesc!: DataDesc;

    private xPager = { itemsPerPage: -1, multiSort: true, sortBy: [], sortDesc: [], initialized: false };

    constructor(dataModule?: DataModule) {
        super();
        if (dataModule) {
            this.xDataModule = dataModule;
            this.xDataModule.initialize();
            this.xDataDesc = this.dataModule.dataSet;
        }
    }

    protected get dataModule() {
        return this.xDataModule;
    }
    protected set dataModule(value: DataModule) {
        this.xDataModule = value;
    }
    protected get dataSet() {
        return this.xDataDesc;
    }
    protected set dataSet(value: DataDesc) {
        this.xDataDesc = value;
    }
    protected get pager() {
        if (
            !!this.xPager &&
            !this.xPager.initialized &&
            this.xPager.sortBy.length === 0 &&
            !!this.dataSet &&
            this.dataSet.state === DatasetState.Loaded
        ) {
            this.dataSet.pagination(this.xPager);
        }
        return this.xPager;
    }
    protected set pager(value: any) {
        this.xPager = value;
    }

    /*
    protected onConfigWidget(data: any) {
        if (!!data && !!this.dataSet) {
            data.fieldDesc = this.dataSet.fieldByName(data.fieldName)!;
        }
    }*/

    // main list functions
    protected get dialogRef(): any {
        return this.$refs.dialog as any;
    }

    protected hndlSelect() {
        this.dataModule.selectMaster();
    }

    protected async hndlUpdate(item: object, isInsert: boolean) {
        const value = await this.dataModule.updateMaster(item, isInsert, this.$i18n);
        if (value) {
            this.dialogRef.closeDialog();
        }
    }

    protected async hndlDelete(item: object) {
        const confirm = String(this.$t('$common.DELETE_ITEM', [this.dataSet.recordDesc]));
        const rc = await this.$confirm(confirm, {
            title: this.$t('$common.DELETE_CONFIRMATION'),
            buttonTrueText: this.$t('$common.OKAY'),
            buttonFalseText: this.$t('$common.CANCEL'),
            color: 'warn',
            icon: 'warn',
            width: 350,
        });

        if (rc) {
            await this.dataModule.deleteMaster(item, this.$i18n);
        }
    }

    protected async hndlBlobData(item: WxIBlobDataItem) {
        item.REFERENCEGUID = this.dataModule.masterItem[this.dataSet.primaryKey];
        await this.dataModule.selectBlobData(item);
    }

    protected hndlConfigWidget(widget: any) {
        if (!!widget && !!this.dataSet) {
            widget.fieldDesc = this.dataSet.fieldByName(widget.fieldName)!;
        }
    }
}
